import {
    Config,
    usePageSettings,
} from '@ratehub/base-ui';


function isStickyMobileAdEnabled(hasAdAboveMenu = false) {
    const pageSettings = usePageSettings();
    return Config.ENABLE_STICKY_MOBILE_AD && (hasAdAboveMenu || pageSettings?.hasAdAboveMenu);
}

export default isStickyMobileAdEnabled;
